import {
    BrowserRouter,
    Route,
    Routes,
} from 'react-router-dom';

import * as screens from '../components/main.jsx';
import { Page } from '../layouts/page.jsx';
import { QuickTermQuoter } from '../products/quickterm-quoter.jsx';

export const QuickTermRoutes = ({ defaultLanding }) => {


    const routeConfig = {
        welcome: screens.DefaultLanding,
        quoter: QuickTermQuoter,
        general: screens.General,
        introduction: screens.Introduction,
        address: screens.Address,
        diagnosis: screens.Diagnosis,
        last10: screens.Last10,
        last5: screens.Last5,
        last2: screens.Last2,
        medical: screens.Medical,
        occupation: screens.Occupation,
        misc: screens.Misc,
        beneficiary: screens.Beneficiary,
        payment: screens.Payment,
        consent: screens.Consent,
        policy: screens.Policy,
        review: screens.Review,
        end: screens.EjectionScreen,
        ineligible: screens.ProductIneligible,
        withdrawn: screens.ProductWithdrawn,
        resume: screens.ResumeQuoteCompnent,
    };

    const DefaultComponent = routeConfig[defaultLanding];


    return (

        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Page />}>
                    <Route index element={<DefaultComponent />} />

                    {Object.entries(routeConfig).map(([path, Component]) => {
                        const routePath = path === 'resume' ? 'resume/:quotenumber' : path;
                        return <Route key={path} path={routePath} element={<Component />} />;
                    })}

                    <Route path="*" element={<DefaultComponent />} />
                </Route>
            </Routes>
        </BrowserRouter>


    )

}

